const translations = {
    dronePrefix: 'S/N',
    emDash: '—',
    faaPrefix: 'FAA',
    firmware: 'Firmware',
    ids: 'IDs',
    unitAcres: 'ac',
    unitDays: 'days',
    unitFlights: 'flights',
    unitHoursShort: 'h',
    usage: 'Usage',
    warranty: 'Warranty',
    warrantyExpPrefix: 'exp',
    warrantyExpired: 'Expired'
};

export default translations;
